/*
* Lietotāju ievadītiem linkiem, izvada paziņojumu par ārēju linku
* Izņēmums, ja links ved uz otrapuse (visi domēni) lapām
* Tērzētavā, vēstulēs
*/
import get from 'lodash/get';

const modal = require('./modal.js');

const safeHosts = [
  'otrapuse.lv',
  's.lindoamor.com',
  'otrapuse.delfi.lv',
  'm.otrapuse.lv',
  'lindoamor.com',
  'lindoamor.lt',
  'lindoamor.ee',
  'tavomeile.lt',
];

module.exports = {
  init() {
    const self = this;
    $(document).on('click', '.external-link', function (event) {
      event.preventDefault();
      const link = $(this).attr('href');
      const location = self.getLocation(link);

      if (!location) {
        return;
      }

      let hostname = location.hostname;
      // noņemt www.
      hostname = hostname.replace('www.', '');

      // pārbauda vai nav drošais domēns
      if (safeHosts.indexOf(hostname) !== -1) {
        // atver jaunā logā
        window.open(link, '_blank');
        return;
      }

      // pārāda brīdinājuma logu par ārējo linku
      let confirmExternalLink = get(translations, 'txt: Ārējais links {:hostname}', '')
        .replace('{:hostname}', get(globals, 'currentDomainName', 'otrapuse.lv'));
      modal.confirm(confirmExternalLink,  (response) => {
        if (response) {
          // atver jaunā logā
          window.open(link, '_blank');
        }
      });
    });
  },
  getLocation(href) {
    // http://stackoverflow.com/a/21553982
    const location = document.createElement('a');
    location.href = href;
    // IE doesn't populate all link properties when setting .href with a relative URL,
    // however .href will return an absolute URL which then can be used on itself
    // to populate these additional fields.
    if (location.host == '') {
      location.href = location.href;
    }
    return location;
  },
};
